import { Box, Col, Container, Heading, Row } from '@dbi-tools/ui-kit';
import { PreloadImage } from '@dbi-tools/ui-kit/lib/preload-image';
import React, { Fragment } from 'react';

import { Question } from '../../types';
import StepsCounter from '../common/steps-counter';
import QuestionSubText from '../question-sub-text';
import QuestionLayout from '../questions/question.layout';
import { ThumbnailImg } from './styled/complex.styled';
import { MainWhiteStyled } from './styled/main.styled';

const SimpleStepLayout: React.FC<{
  question: Question;
  title: string;
  image: string;
}> = ({ question, title, image }) => {
  return (
    <Fragment>
      <Container>
        <MainWhiteStyled>
          <StepsCounter />
          <Heading as="h1" measure={{ xs: 'h4', md: 'h3' }} mb={15}>
            {question?.question}
          </Heading>
          {question && (
            <Row>
              <Col lg={8}>
                <Box mb={20}>
                  <QuestionSubText text={question?.text} />
                </Box>
                <QuestionLayout question={question} />
              </Col>
              <Col lg={4}>
                <Box display={{ xs: 'none', lg: 'block' }} mr={-60}>
                  <ThumbnailImg>
                    <PreloadImage src={image} alt={title} />
                  </ThumbnailImg>
                </Box>
              </Col>
            </Row>
          )}
        </MainWhiteStyled>
      </Container>
    </Fragment>
  );
};

export default SimpleStepLayout;
